import axios from "axios";
import Cookies from "js-cookie";

const BASE_URL = process.env.REACT_APP_BACKEND_URL;

// Axios Instance
const API = axios.create({
  baseURL: BASE_URL,
  withCredentials: true,
});

// Attach Token Automatically
API.interceptors.request.use((config) => {
   const token = Cookies.get("authToken");

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

/* =====================================================
   EXPLORE COURSE
===================================================== */

export const createExploreCourse = (data) =>
  API.post("/apis/admin/createExploreCourse", data);

export const getAllExploreCourse = () =>
  API.get("/apis/admin/getAllExportCourse");

export const updateExploreCourse = (id, data) =>
  API.put(`/apis/admin/updateExploreCourse/${id}`, data);

export const deleteExploreCourse = (id) =>
  API.post(`/apis/admin/deleteExploreCourse/${id}`);


/* =====================================================
   UNDER GRADUATE COURSE
===================================================== */

export const createUnderGraduateCourse = (exploreCourseId, data) =>
  API.post(`/apis/admin/createUnderGraduateCourse/${exploreCourseId}`, data);

export const getAllUnderGraduateCourse = () =>
  API.get("/apis/admin/getAllUnderGraduateCourse");

export const getSingleUnderGraduateCourseThoughExploreCourse = (exploreCourseId) =>
  API.get(`/apis/admin/getSingleUnderGraduateCourseThoughExploreCourse/${exploreCourseId}`);

export const updateUnderGraduateCourse = (underGraduateId, data) =>
  API.put(`/apis/admin/updateUnderGraduateCourse/${underGraduateId}`, data);

export const deleteUnderGraduateCourse = (underGraduateId) =>
  API.post(`/apis/admin/deleteUnderGraduateCourse/${underGraduateId}`);


/* =====================================================
   POST GRADUATE COURSE
===================================================== */

export const createPostGraduateCourse = (exploreCourseId, data) =>
  API.post(`/apis/admin/createPostGraduateCourse/${exploreCourseId}`, data);

export const getAllPostGraduateCourse = () =>
  API.get("/apis/admin/getAllPostGraduateCourse");

export const getSingPostGraduateCourseThroughExploreCourse = (exploreCourseId) =>
  API.get(`/apis/admin/getSingPostGraduateCourseThroughExploreCourse/${exploreCourseId}`);

export const updatePostGraduateCourse = (postGraduateId, data) =>
  API.put(`/apis/admin/updatePostGraduateCourse/${postGraduateId}`, data);

export const deletePostGraduateCourse = (postGraduateId) =>
  API.post(`/apis/admin/deletePostGraduateCourse/${postGraduateId}`);


/* =====================================================
   ADMISSION TYPE
===================================================== */

export const createAdmissionType = (exploreCourseId, data) =>
  API.post(`/apis/admin/createAdmissionType/${exploreCourseId}`, data);

export const getAllAdmissionType = () =>
  API.get("/apis/admin/getAllAdmissionType");

export const getSingleAdmissionTypeThroughByExploreId = (exploreCourseId) =>
  API.get(`/apis/admin/getSingleAdmissionTypeThroughByExploreId/${exploreCourseId}`);

export const updateAdmissionType = (admissionMenuId, data) =>
  API.put(`/apis/admin/updateAdmissionType/${admissionMenuId}`, data);

export const deleteAdmissionType = (admissionMenuId) =>
  API.post(`/apis/admin/deleteAdmissionType/${admissionMenuId}`);


/* =====================================================
   UNDER GRADUATE MENU
===================================================== */

export const createUnderGraduateMenu = (underGraduateCourseId, data) =>
  API.post(`/apis/admin/createUnderGraduateMenu/${underGraduateCourseId}`, data);

export const getAllUnderGraduateMenu = () =>
  API.get("/apis/admin/getAllUnderGraduateMenu");

export const getSingleUnderGraduateMenuThoroughCourse = (underGraduateCourseId) =>
  API.get(`/apis/admin/getSingleUnderGraduateMenuThoroughCourse/${underGraduateCourseId}`);

export const updateUnderGraduateMenu = (underGraduateMenuId, data) =>
  API.put(`/apis/admin/updateUnderGraduateMenu/${underGraduateMenuId}`, data);

export const deleteUnderGraduateMenu = (underGraduateMenuId) =>
  API.post(`/apis/admin/deleteUnderGraduateMenu/${underGraduateMenuId}`);


/* =====================================================
   POST GRADUATE MENU
===================================================== */

export const createPostGraduateMenu = (postGraduateCourseId, data) =>
  API.post(`/apis/admin/createPostGraduateMenu/${postGraduateCourseId}`, data);

export const getAllPostGraduateMenu = () =>
  API.get("/apis/admin/getAllPostGraduateMenu");

export const getSinglePostGraduateMenuThroughByCourseId = (postGraduateCourseId) =>
  API.get(`/apis/admin/getSinglePostGraduateMenuThroughByCourseId/${postGraduateCourseId}`);

export const updatePostGraduateMenu = (postGraduateMenuId, data) =>
  API.put(`/apis/admin/updatePostGraduateMenu/${postGraduateMenuId}`, data);

export const deletePostGraduateMenu = (postGraduateMenuId) =>
  API.post(`/apis/admin/deletePostGraduateMenu/${postGraduateMenuId}`);


/* =====================================================
   UNDER GRAD MENU DESCRIPTION (FILE UPLOAD)
===================================================== */

export const addArticleInUnderGraduateMenuDescription = (underGraduateMenuId, formData) =>
  API.post(
    `/apis/admin/addArticleInUnderGraduateMenuDescription/${underGraduateMenuId}`,
    formData,
    { headers: { "Content-Type": "multipart/form-data" } }
  );

export const getAllArticleInUnderGraduateMenuDescription = () =>
  API.get("/apis/admin/getAllArticleInUnderGraduateMenuDescription");

export const getSingleArticleInUnderGraduateMenuDescriptionThoughMenuId = (underGraduateMenuId) =>
  API.get(`/apis/admin/getSingleArticleInUnderGraduateMenuDescriptionThoughMenuId/${underGraduateMenuId}`);

export const updateAllArticleInUnderGraduateMenuDescription = (id, formData) =>
  API.put(
    `/apis/admin/updateAllArticleInUnderGraduateMenuDescription/${id}`,
    formData,
    { headers: { "Content-Type": "multipart/form-data" } }
  );

export const deleteAllArticleInUnderGraduateMenuDescription = (id) =>
  API.post(`/apis/admin/deleteAllArticleInUnderGraduateMenuDescription/${id}`);


/* =====================================================
   POST GRAD MENU DESCRIPTION (FILE UPLOAD)
===================================================== */

export const createPostGraduateMenuDescription = (postGraduateMenuId, formData) =>
  API.post(
    `/apis/admin/createPostGraduateMenuDescription/${postGraduateMenuId}`,
    formData,
    { headers: { "Content-Type": "multipart/form-data" } }
  );

export const getAllPostGraduateMenuDescription = () =>
  API.get("/apis/admin/getAllPostGraduateMenuDescription");

export const getSinglePostGraduateMenuDescriptionThroughBy = (postGraduateMenuId) =>
  API.get(`/apis/admin/getSinglePostGraduateMenuDescriptionThroughBy/${postGraduateMenuId}`);

export const updatePostGraduateMenuDescription = (id, formData) =>
  API.put(
    `/apis/admin/updatePostGraduateMenuDescription/${id}`,
    formData,
    { headers: { "Content-Type": "multipart/form-data" } }
  );

export const deletePostGraduateMenuDescription = (id) =>
  API.post(`/apis/admin/deletePostGraduateMenuDescription/${id}`);


/* =====================================================
   ADMISSION MENU
===================================================== */

export const createAdmissionMenu = (admissionTypeId, data) =>
  API.post(`/apis/admin/createAdmissionMenu/${admissionTypeId}`, data);

export const getAllAdmissionMenu = () =>
  API.get("/apis/admin/getAllAdmissionMenu");

export const getSingleAdmissionMenuThoughByAdmissionTypeId = (admissionTypeId) =>
  API.get(`/apis/admin/getSingleAdmissionMenuThoughByAdmissionTypeId/${admissionTypeId}`);

export const updateAdmissionMenu = (admissionMenuId, data) =>
  API.get(`/apis/admin/updateAdmissionMenu/${admissionMenuId}`, data); // your route uses GET (keeping same)

export const deleteAdmissionMenu = (admissionMenuId) =>
  API.post(`/apis/admin/deleteAdmissionMenu/${admissionMenuId}`);


/* =====================================================
   ADMISSION MENU DESCRIPTION (FILE UPLOAD)
===================================================== */

export const createAdmissionMenuDescription = (admissionMenuId, formData) =>
  API.post(
    `/apis/admin/createAdmissionMenuDescription/${admissionMenuId}`,
    formData,
    { headers: { "Content-Type": "multipart/form-data" } }
  );

export const getAllAdmissionMenuDescription = () =>
  API.get("/apis/admin/getAllAdmissionMenuDescription");

export const getSingleAdmissionMenuDescriptionThoughByAdmissionMenuId = (admissionMenuId) =>
  API.get(`/apis/admin/getSingleAdmissionMenuDescriptionThoughByAdmissionMenuId/${admissionMenuId}`);

export const updateAdmissionMenuDescription = (id, formData) =>
  API.put(
    `/apis/admin/updateAdmissionMenuDescription/${id}`,
    formData,
    { headers: { "Content-Type": "multipart/form-data" } }
  );

export const deleteAdmissionMenuDescription = (id) =>
  API.post(`/apis/admin/deleteAdmissionMenuDescription/${id}`);

// Add these missing functions to your service.js

// =====================================================
// UNDER GRADUATE MENU DESCRIPTION
// =====================================================

export const getUnderGraduateMenuDescriptions = (menuId) =>
  API.get(`/apis/admin/getSingleArticleInUnderGraduateMenuDescriptionThoughMenuId/${menuId}`);

export const createUnderGraduateMenuDescription = (menuId, formData) =>
  API.post(`/apis/admin/addArticleInUnderGraduateMenuDescription/${menuId}`, formData, {
    headers: { "Content-Type": "multipart/form-data" }
  });

export const updateUnderGraduateMenuDescription = (descriptionId, formData) =>
  API.put(`/apis/admin/updateAllArticleInUnderGraduateMenuDescription/${descriptionId}`, formData, {
    headers: { "Content-Type": "multipart/form-data" }
  });

export const deleteUnderGraduateMenuDescription = (descriptionId) =>
  API.post(`/apis/admin/deleteAllArticleInUnderGraduateMenuDescription/${descriptionId}`);

// =====================================================
// POST GRADUATE MENU DESCRIPTION
// =====================================================

export const getPostGraduateMenuDescriptions = (menuId) =>
  API.get(`/apis/admin/getSinglePostGraduateMenuDescriptionThroughBy/${menuId}`);



// =====================================================
// ADMISSION MENU DESCRIPTION
// =====================================================

export const getAdmissionMenuDescriptions = (menuId) =>
  API.get(`/apis/admin/getSingleAdmissionMenuDescriptionThoughByAdmissionMenuId/${menuId}`);


